<div class="flex items-start gap-2">
    <img class="w-8 h-8 rounded-full object-cover flex-shrink-0" [src]="avatar+'?size=48'" *ngIf="avatar">
    <div class="w-8 h-8 rounded-full bg-[#E8EAEF] text-gray-500 flex items-center justify-center text-xs font-semibold flex-shrink-0" *ngIf="!avatar">
        {{ avatarInitial }}
    </div>

    <div class="flex-1 min-w-0">
        <label class="block">
            <input type="text" placeholder="{{ placeholder }}" [(ngModel)]="message" debounce="1000" required
                class="timeline-add-input" (focus)="inputActive = true" (blur)="inputActive = false">
        </label>

        <div class="add-content__actions">
            <button *ngIf="!media" class="add-media "  (click)="open(modalMedia)">{{'player.timeline.add-media' | translate}}</button>

            <button (click)='onAddContent(message)' type="submit" class="btn btn_action_post send-btn"
                [disabled]="!inputActive && !message?.trim()"
                [ngClass]="(inputActive || message?.trim()) ? 'send-btn--active' : 'send-btn--disabled'">
                {{'player.timeline.button-send-message' | translate }}
            </button>
        </div>

        <div *ngIf="media" class="media-manager media-manager_mini" style="height: 80px; width: 200px;">
            <media-holder [media]="media" [mini]="true"></media-holder>
            <div class="media-manager__actions">
                <button class="btn btn_color_red delete" (click)="deleteMediaPreview()">
                    <span class="sr-only">{{ 'words.delete' | translate }}</span>
                </button>
            </div>
        </div>
    </div>
</div>

<ng-template #modalMedia let-modal>
    <library-modal (closeModal)="modal.close($event)" (updateMedia)="onUpdatedMedia($event)"></library-modal>
</ng-template>

<style>
    /* Border gris claro siempre, sin cambio de color al enfocar */
    .timeline-add-input,
    .timeline-add-input:focus,
    .timeline-add-input:active {
        border-top: 1px solid #E5E7EB !important;
        border-right: 1px solid #E5E7EB !important;
        border-bottom: 1px solid #E5E7EB !important;
        border-left: 1px solid #E5E7EB !important;
        border-radius: 10px !important;
        outline: none !important;
        box-shadow: none !important;
    }

    /* Fila debajo del input: "Añadir archivos" a la izquierda, "Enviar" a la derecha */
    .add-content__actions {
        display: flex !important;
        align-items: center !important;
        justify-content: space-between !important;
        margin-top: .5rem !important;
    }

    .add-content__actions .add-media {
        float: none !important;
        margin: 0 !important;
        text-align: left !important;
    }

    /* Botón Enviar: gris/deshabilitado hasta que el input esté activo o tenga texto */
    .send-btn--active {
        background: var(--primary-500) !important;
        color: #fff !important;
        cursor: pointer !important;
    }

    .send-btn--disabled {
        background: #E5E7EB !important;
        color: #9CA3AF !important;
        cursor: default !important;
    }
</style>
